import React, { useEffect, useState } from 'react';
import DirectionService from '../../../services/DirectionService';
import MissionTransportService from '../../../services/MissionTransportService';
import { Dialog } from '@material-ui/core';
import { Alert, Autocomplete, Box, Button, Chip, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, TextField } from '@mui/material';
import Spacer from '../../../components/Spacer';
import TimeToLeaveIcon from '@mui/icons-material/TimeToLeave';
import CardTravelIcon from '@mui/icons-material/CardTravel';
import DateRangeIcon from '@mui/icons-material/DateRange';
import PlaceIcon from '@mui/icons-material/Place';
import SendIcon from '@mui/icons-material/Send';

const bullRed = (
  <Box
    component="span"
    sx={{
      display: "inline-block",
      mx: "5px",
      transform: "scale(0.8)",
      color: "red",
      fontSize: "20px",
    }}
  >
    *
  </Box>
);

const MissionVehicleRequest = (props) => {
    const { formRequest, setFormRequest, setMessage } = props;
    const [directions, setDirections] = useState([]);

    useEffect(() => {
        async function fetchDirections() {
              try {
                const result = await DirectionService.getDirection();
                if (result?.data) {
                  setDirections(result.data);
                }
              } catch (error) {
                console.error("Error fetching directions:", error);
              }
            }
    
        fetchDirections();
    }, []);

    const handleRequestDirection = async () => {
        if(!formRequest.direction || !formRequest.missionnaries){
          setMessage({ open: true, color: 'red', messageInfo: 'Veuillez remplir tous les champs obligatoires' });
          return;
        }
    
        const dataToSend = {
          mission_planning_id: formRequest.missionId,
          direction_id : formRequest.direction,
          comment : formRequest.comment,
          mission_planning_agenda_details : formRequest.missionnaries.map((missionnary) => missionnary.mission_planning_agenda_details_id),
        }
    
        try{
          const result = await MissionTransportService.sendVehicleRequestDirection(dataToSend);
          if(result){
            setMessage({ open: true, color: 'green', messageInfo: 'La demande a été envoyée avec succès' });
            setFormRequest({ 
              show: false,
              direction: null,
              description: "",
              missionnaries: {},
              allMissionnaries: [],
              destination: {},
              agendaId: 0,
              missionId: 0,
             });
          }
        } catch(err){
          setMessage({ open: true, color: 'red', messageInfo: 'Erreur lors de l\'envoi de la demande' });
        }
      };
    
      const handleChangeRequest = (event, name, value) => {
        setFormRequest({
          ...formRequest,
          [name]: value,
        });
      };
    
    return (
        <Dialog
        open={formRequest.show}
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ "& .MuiDialog-paper": { width: "60vw !important", maxWidth: "none" } }}
        onClose={ 
          () => setFormRequest({ 
            show: false,
            direction: null,
            description: "",
            missionnaries: {},
            allMissionnaries: [],
            destination: {},
            agendaId: 0,
            missionId: 0,
          })
        }
        >
          <DialogTitle id="form-dialog-title" color="info">{"Demande de sollicitation d'une voiture"} </DialogTitle>
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description">
              <i>Le responsable auprès de la direction sélectionné sera chargé d'assigner une voiture pour cette ligne d'agenda.</i>
              <Alert severity="info"> <DateRangeIcon sx={{fontSize: '18px'}}/>  ({new Date(formRequest.destination.date_begin).toLocaleDateString()} - {new Date(formRequest.destination.date_end).toLocaleDateString()}) - <PlaceIcon sx={{fontSize: '18px'}} /> ({formRequest.destination.depart} - {formRequest.destination.arriver} )
              -  {formRequest.destination.type === 'DM' ? (
                          <Chip icon={<CardTravelIcon />} label="Mission" variant="outlined" color="info" />
                        ) : (
                          <Chip icon={<TimeToLeaveIcon />} label="Délai de route" variant="outlined" color="info" />
                        )}
                </Alert>
             
              <FormControl fullWidth variant="outlined" size="small">
                <label>Direction de la demande {bullRed}</label>
                <Autocomplete
                  id="tags-outlined"
                  options={directions}
                  getOptionLabel={(option) => (option ?  option.name + '('+ option.code + ')' : '')}
                  filterSelectedOptions
                  onChange={(event, value) => handleChangeRequest(event, 'direction', value.direction_id)}
                  value={directions.find((d) => d.direction_id === formRequest.direction)}
                  fullWidth
                  renderInput={(params) => <TextField {...params} label="Direction" variant="outlined" size="small" />}
                />
              </FormControl>
              <Spacer y={1} />
              <FormControl fullWidth variant="outlined" size="small">
                <label>Missionnaires {bullRed}</label>
                <Autocomplete
                  multiple
                  id="tags-outlined"
                  options={formRequest.allMissionnaries || []}
                  getOptionLabel={(option) => (option ? option.nom : '')}
                  filterSelectedOptions
                  onChange={(event, value) => handleChangeRequest(event, 'missionnaries', value)}
                  value={formRequest.missionnaries}
                  fullWidth
                  renderInput={(params) => <TextField {...params} label="Missionnaires" variant="outlined" size="small" />}
                />
              </FormControl>
              <FormControl fullWidth variant="outlined" size="small">
                <label>Commentaire</label>
              <TextField
                  multiline
                  rows={4}
                  variant="outlined"
                  fullWidth
                  onChange={(event) => handleChangeRequest(event, 'comment', event.target.value)}
                  InputProps={{
                    sx: { 
                      overflow: "auto"
                    }
                  }}
                  />
              </FormControl>
            </DialogContentText>
            </DialogContent>
            <DialogActions >
              <Button onClick={() => setFormRequest({ ...formRequest, show: false })} variant="outlined" >
                Annuler
              </Button>
              <Button startIcon={<SendIcon/>} variant="contained" onClick={handleRequestDirection} color="primary" autoFocus>
                Envoyer la demande
              </Button>
            </DialogActions>
        </Dialog>
    );
}

export default MissionVehicleRequest;
